import React from "react";
import { STAFF_ROLES } from "../../constants/staffRoles";

export default function ClientTeam({ staff, excludeEmployeeId }) {
  const items = [];

  for (const { code, label } of STAFF_ROLES) {
    const others = staff.filter((m) => m.role === code && m.employee_id !== excludeEmployeeId);
    const heldByAbsent = staff.some((m) => m.role === code && m.employee_id === excludeEmployeeId);

    if (others.length > 0) {
      items.push(
        <span className="vs-team__item" key={code}>
          <span className="vs-team__role">{label}:</span>{" "}
          <span className="vs-team__names">{others.map((m) => m.full_name).join(", ")}</span>
        </span>
      );
    } else if (code !== "bank" && !heldByAbsent) {
      items.push(
        <span className="vs-team__item vs-team__item--missing" key={code}>
          <span className="vs-team__role">{label}:</span>{" "}
          <span className="vs-team__names">не назначен</span>
        </span>
      );
    }
  }

  if (items.length === 0) return null;
  return <div className="vs-team">{items}</div>;
}
